import {Component, HostListener, OnInit, ViewContainerRef} from '@angular/core';
import { Store } from '@ngrx/store';
import { TokenStorageService } from './core/services/token-storage.service';
import { AppState } from './core/store/app.state';
import { UpdateUserAuthDetails } from './core/store/userAuth/userAuth.actions';
import { BaseModalService } from './core/services/base-modal.service';
import {NavigationEnd, Router} from '@angular/router';
import * as UserAuthActions from "@app/core/store/userAuth/userAuth.actions";
import {IoReusableElement} from "@app/layout/components/io-reusable-components/element-models";
import {AutoLogoutService} from "@app/core/services/auto-logout.service";
import {Amplify} from "aws-amplify";
import {environment} from "@env/environment";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    private tokenService: TokenStorageService,
    private store: Store<AppState>,
    private vc: ViewContainerRef,
    private baseModalService: BaseModalService,
    private router: Router,
    private autoLogoutService: AutoLogoutService,
  ) {}
  title = 'Iowa Ortho Partner Portal';

  ngOnInit() {
    this.baseModalService.setViewContainer(this.vc);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo({ top: 0, behavior: 'smooth'});
      }
    });
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: environment.cognitoUserPoolId,
          userPoolClientId: environment.cognitoAppClientId,
          loginWith: {
            email: true
          }
        }
      }
    });
  }

  // This is used to handle cross tab logout. We instantly log out if any other tab has logged out. We don't need the time
  // at the moment, but passing it in case we would in the future (to compare it or something).
  @HostListener('window:storage', ['$event'])
  onStorageChange(event: StorageEvent) {
    if(event.storageArea === localStorage && event.key === 'logout-time'){
      this.store.dispatch(UserAuthActions.LogoutOnAlternateTab({logoutTime: event.newValue ?? ''}));
    }
  }
}
